// 判断是不是安卓机型
export function checkAndroid() {
  var browser = {
    versions: (function () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        // 移动终端浏览器版本信息
        trident: u.indexOf("Trident") > -1, // IE内核
        presto: u.indexOf("Presto") > -1, // opera内核
        webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), // 是否为移动终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, // 是否iPad
        webApp: u.indexOf("Safari") == -1,
        // 是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
  };
  if (browser.versions.android) {
    return true;
  } else return false;
}

export function setRem() {
  //获取html元素
  const html = document.getElementsByTagName("html")[0];
  //屏幕的宽度（兼容处理）
  const w = document.documentElement.clientWidth || document.body.clientWidth;
  //750这个数字是根据你的设计图的实际大小来的，所以值具体根据设计图的大小
  html.style.fontSize = w / 37.5 + "px";
}

export function changeInputContent(dom, num) {
  dom.style.marginTop = `${num}rem`;
}



// WEBPACK FOOTER //
// ./src/utils/device.js